import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../css/Signup.css";

const Signup = () => {
  const navigate = useNavigate();
  const [verificationCode, setVerificationCode] = useState(null);  // initially null
  const [error, setError] = useState('');



  const handleCodeChange = (e) => {
    setVerificationCode(e.target.value);
  };


  const [formData, setFormData] = useState({
    fullName: "",
  
    mobile: "",
    email: "",
    password: "",
    
    
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    setFormData((prevData) => ({
      ...prevData,
      image: e.target.files[0],
    }));
  };
  //alert(JSON.stringify(formData));


  // Add this near the top of your component, after the useState declarations
  const API_BASE_URL =  "https://api.postlii.com";
  
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!verificationCode) {
      setError('Verification code is required');
      return;
    }

    try {
      console.log('Sending data:', { ...formData, verificationCode });

      const response = await fetch(`${API_BASE_URL}/api/signup`, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          ...formData,
          verificationCode: verificationCode
        })
      });

      // Log the raw response for debugging
      const rawResponse = await response.text();
      console.log('Raw server response:', rawResponse);

      let result;
      try {
        result = JSON.parse(rawResponse);
      } catch (parseError) {
        console.error('Failed to parse response:', rawResponse);
        toast.error('Server response error. Please try again.');
        return;
      }

      if (response.ok) {
        console.log("Signup success:", result);
        
        if (!result.user || !result.user._id) {
          console.error("Invalid response format:", result);
          toast.error("Invalid server response");
          return;
        }

        const userId = result.user._id;
        const tempToken = `temp_${Date.now()}_${userId}`;
        
        // Clear any existing auth data
        localStorage.clear();
        // Set new auth data
        localStorage.setItem('userId', userId);
        localStorage.setItem('authToken', tempToken);
       
        toast.success("Registration successful!");
        
        setTimeout(() => {
          navigate(`/ProfileSelection?userId=${userId}`);
        }, 2000);
      } else {
        toast.error(result.message || "Registration failed");
      }
    } catch (error) {
      console.error("Signup error:", error);
      toast.error(error.message || "An unexpected error occurred");
    }
  };

  // Social Login Handlers
  const handleGoogleLogin = () => {
    window.location.href = `https://api.postlii.com/auth/google`;
  };

  const handleFacebookLogin = () => {
    window.location.href = `${API_BASE_URL}/auth/facebook`;
  };

  const handleAppleLogin = () => {
    window.location.href = `${API_BASE_URL}/auth/apple`;
  };

  return (
    <div className="signup-container">
      
     
      <div className="hero-container">

  <div className="hero-text">
  <div className="branding">
    <h1 className="postlii-title">postlii</h1>
  </div>
    <h1 className="main-heading">Connect with your community in one place</h1>
    <p className="subtext">
      Join thousands of people who trust Postlii to stay connected with their local community
    </p>
  </div>
  <div className="hero-image">
    <img src={"signupp.jpg"} alt="Community Connection" />
  </div>

</div>

      <div className="signup-box">
        <h2>Create your account</h2>
        <div className="social-login">
          <p>join postlii to connect with your community</p>
          <button className="google-btn" onClick={handleGoogleLogin}>Sign Up with Google</button>
          <button className="facebook-btn" onClick={handleFacebookLogin}>Sign Up with Facebook</button>
          {/* <button className="apple-btn" onClick={handleAppleLogin}>Sign Up with Apple</button> */}
       

        </div>
        <div className="divider">
            <span>or</span>
          </div>
        <form onSubmit={handleSubmit}>
        <div className="input-row">

   <div>
    <label htmlFor="fullName">Full Name</label>
    <input type="text" name="fullName" placeholder="Full Name" required onChange={handleChange} />
  </div>
</div>

<div className="input-row">
  <div>
    <label htmlFor="mobile">Mobile No</label>
    <input type="number" name="mobile" placeholder="Mobile No" required onChange={handleChange} />
  </div>
 
</div>


<div className="input-row">
<div>
    <label htmlFor="email">Email</label>
    <input type="email" name="email" placeholder="Email" required onChange={handleChange} />
  </div>
  </div>

<div className="input-row">
  <div>
    <label htmlFor="password">Password</label>
    <input type="password" name="password" placeholder="Password" required onChange={handleChange} />
  </div>

</div>



<div className="input-row1" >
<div>
  <label htmlFor="verificationCode">Verification Code</label>
  <input 
    type="text" 
    id="verificationCode" 
    name="verificationCode" 
     
    onChange={handleCodeChange} 
    placeholder="Enter verification code" 
  />
</div>
</div>



          
          <button type="submit" className="create-account">
              Create Account
            </button>

          <p className="login-link">
            Already have an account? <span onClick={() => navigate("/login-User")} style={{ cursor: "pointer", color: "blue" }}>Login</span>
          </p>
        </form>

        {/* Social Logins */}
      
      </div>

      <ToastContainer closeButton={false} />
    </div>
  );
};

export default Signup;